<template>
  <div id="my-password-sent reverse-mobile" class="row">
    <div class="col-12 col-md-3">
      <UserMenu></UserMenu>
    </div>
    <div class="col-12 col-md-9">
      <h3>Email Sent!</h3>
      <div class="row">
        <div class="col-12">
          <p>We have sent you an email with further instructions on how to reset your password.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
import UserService from "../services/user.service";
export default {
  name: "MyPasswordSent",
  components: {
    UserMenu
  },
  methods: {}
};
</script>

<style scoped>
</style>
